import { Component, OnInit,TemplateRef, ViewChild } from '@angular/core';
import {MychampService} from '../services/mychamp.service'
import {MasterService} from '../services/master.service'
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers:[MychampService,MasterService]
})
export class ProfileComponent implements OnInit {


  ngtab:any[];
  objprof:any={};
  bloodgp:any=[];
  arrlinks:any=[];
  arrcourse:any=[];
  ipactive="";
  pmodel:any={};
  objhob:any={};
  primagepath:any="";
  tab=1;
  enablejob:any;
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  fileToUpload: File = null;

  fData: FormData = new FormData;
  disuploadbtn=true;

  @ViewChild('workmdl')
private workmdl: TemplateRef<any>;

@ViewChild('edumdl')
private edumdl: TemplateRef<any>;

@ViewChild('hobmdl')
private hobmdl: TemplateRef<any>;


  constructor(private mservice: MychampService,private msservice: MasterService,private modalService: NgbModal) {

    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
    }
   }

  ngOnInit(): void {
    this.enablejob=localStorage.getItem('placement');
  this.ngtab=[{
    Bio:"true"
  }];
  this.getusefullink();
  this.getactiveip();
  this.masbloodgroup();
  this.mascourse();
 
  }

  upload(files: FileList) {
    debugger;
    this.fileToUpload = files.item(0);
  if(files==null || files==undefined)
  {
    this.disuploadbtn=true;
  }
  else{
    this.disuploadbtn=false;
  }
   
  }
  fileupload()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));

this.mservice.uploadmemberphoto(this.fileToUpload,this.objprof)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    if(fresult.status=='Success')
{
// let localmodref=this.modalRef;
// localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;

this.disuploadbtn=true;
//this.getstudentdocs(this.stuid);
}
    
}, error => 
alert('error in connection')

);



}

  masbloodgroup() {
    this.msservice.masbloodgroups()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.bloodgp = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  mascourse() {
    this.msservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            const result = resultArray.filter((obj) => {
              return obj.crcatid === '0';
            });
            this.arrcourse = result;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getusefullink() {
    this.msservice.getusefullink()
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrlinks = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getprofiledata()
  {
      this.mservice.getstudentprofile()
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.objprof=resultArray;
      this.primagepath=this.ipactive+resultArray.docpath;
      console.log('primagepath-dashcounts',this.primagepath) ;
      


      },
     error => console.log('Error :: ' + error)
  );
  }

  getactiveip()
  {
    this.msservice.getipurl()
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      this.ipactive=resultArray;
      
      this.getprofiledata();

      },
     error => console.log('Error :: ' + error)
  );
  }

  openmodaldlg(content)
  {
    if (content.toString()=='workmdl')
    {

this.openworkinfo (this.workmdl);
    }

    else if (content.toString()=='edumdl')
    {

this.openeduinfo (this.edumdl);
    }

    else if (content.toString()=='hobmdl')
    {

this.openhobbies (this.hobmdl);
    }
  }

  openpubmodal (content) {

    
        
        this.modalOptions.size='lg';
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }

      
      openworkinfo (content) {

    alert('workinfo');
        
    this.modalOptions.size='lg';
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  openeduinfo (content) {

    
        
    this.modalOptions.size='lg';
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  openhobbies (content) {

    
        
    this.modalOptions.size='lg';
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  openprofileupload (content) {

    
        
    this.modalOptions.size='md';
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  save_profileinfo(oprtype)
  {
    this.objprof.oprtype=oprtype;
    this.mservice.saveprofileinfo(this.objprof)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result',resultArray) ;
      
      // if(resultArray.status=="success")
      // {}
      alert(resultArray.message);
      this.getprofiledata();

      },
     error => console.log('Error :: ' + error)
  );
  }

  confirm_register(tag)
  {
    if(tag=="YES")
    {
if(confirm("Do you wan't to register for placement..?"))
{
  this.updateplacement(tag);
}
    }

    else if(tag=="NO")
    {
if(confirm("Are you sure? you wan't to cancel placement registration?"))
{
  this.updateplacement(tag);
}
    }
  }

  updateplacement(tag)
  {
      this.mservice.updateplacement(tag)
    .subscribe(
           resultArray =>{
   // this.liservice.Getdashboarddata('dashcounts')
      console.log('result-dashcounts',resultArray) ;
      alert(resultArray.message);
      this.getprofiledata();


      },
     error => console.log('Error :: ' + error)
  );
  }

}
